import React, { Component } from 'react';

export default class CardHeader extends Component {
    render() {
        return (
            <div className="card-header bg-transparent">
                <div className="row align-items-center">
              <div className="col">
                <h6 className="text-uppercase text-light ls-1 mb-1">Visão Geral</h6>
                <h2 className="mb-0">Entradas x Saídas</h2>
              </div>
            </div>
          </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/ZWallet/Dashboard/components/OverviewChart/CardHeader.js